import { addStyles } from 'ethcss'
import { grid, IStyles, colors } from '../../theme'
import { defaultThemeStyles } from './datepicker.theme'
import { palette } from '../../theme/tokens/palette'

const itemWidth = {
    width: '2.5rem',
    lineHeight: '2.5rem',
    fontSize: 16,
}

const selectedDayColor = palette.info[700]

const datePickerStyles: IStyles = {
    datepickerWrapper: {
        '& .react-datepicker__navigation': {
            //backgroundColor: `var(--var-module-ui-component-range-style-navigation, ${defaultThemeStyles.navigation})`,
            backgroundColor: 'none',
            border: 'none',
            width: '32px',
            top: '2px !important',
        },
        '& .react-datepicker__week-number': {
            cursor: 'pointer',
        },
        '& .react-datepicker__day--highlighted': {
            backgroundColor: `var(--var-module-ui-component-range-style-selected, ${defaultThemeStyles.selected})`,
            color: colors.white,
            '&:hover': {
                backgroundColor: `var(--var-module-ui-component-range-style-selected, ${defaultThemeStyles.selected})`,
            },
        },
        '& .react-datepicker__day--selected, & .react-datepicker__day--in-selecting-range, & .react-datepicker__day--in-range': {
            backgroundColor: `${selectedDayColor} !important`,
            color: `${colors.white} !important`,
            '&:hover': {
                backgroundColor: `${selectedDayColor} !important`,
            },
        },
        '& .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--highlighted)': {
            backgroundColor: 'transparent',
            color: 'inherit',
            '&:hover': {
                backgroundColor: '#f0f0f0',
            },
        },
        '& .react-datepicker__day--today': {
            position: 'relative',
            fontWeight: 'normal',
            '&::after': {
                content: '""',
                position: 'absolute',
                right: '0',
                top: '3px',
                width: '5px',
                height: '5px',
                borderRadius: '50%',
                backgroundColor: colors.blue,
                transform: 'translateX(-50%)',
            },
        },
        '& .react-datepicker__day--today:not(.react-datepicker__day--selected):not(.react-datepicker__day--highlighted)': {
            backgroundColor: 'transparent',
        },
    },
    inline: {
        border: 'none!important',
        boxShadow: '0px 3px 13.5px 1.5px rgba(0, 0, 0, 0.2)',
        '& .react-datepicker__navigation': {
            top: 25,
            backgroundColor: `var(--var-module-ui-component-range-style-background, ${defaultThemeStyles.background})!important`,
        },
        '& .react-datepicker__header': {
            backgroundColor: `var(--var-module-ui-component-range-style-background, ${defaultThemeStyles.background})`,
            borderBottom: `2px solid var(--var-module-ui-component-range-style-border, ${defaultThemeStyles.border})`,

            '& .react-datepicker__current-month': {
                ...grid.pt_mini,
                ...grid.pb_mini,
                color: `var(--var-module-ui-component-range-style-currentMonthText, ${defaultThemeStyles.currentMonthText})`,
                textTransform: 'capitalize',
                fontSize: 18,
            },
            '& .react-datepicker__day-name': {
                fontWeight: 'bold',
                ...itemWidth,
            },
        },
        '& .react-datepicker__day': {
            ...itemWidth,
        },
        '& .react-datepicker__week-number': {
            ...itemWidth,
        },
    },
}

addStyles(datePickerStyles)
export default datePickerStyles
